import React from 'react';
import { HelpCircle } from 'lucide-react';

export function FAQ() {
  const faqs = [
    {
      question: "What makes this the best free blog title generator?",
      answer: "Our tool combines AI technology with proven headline formulas to generate engaging, SEO-optimized titles. It offers customization options for different industries and content goals, making it versatile for all content creators."
    },
    {
      question: "How does the blog title generator work?",
      answer: "The generator uses advanced AI algorithms and proven headline templates to create compelling titles based on your input topic and keywords. It considers factors like emotional impact, curiosity, and SEO optimization."
    },
    {
      question: "Is this title generator really free?",
      answer: "Yes, the basic version of our blog title generator is completely free to use. For advanced features and AI-powered generation, you'll need to provide your own OpenAI API key."
    },
    {
      question: "Can I use the generated titles for commercial purposes?",
      answer: "Yes, all generated titles are free to use for any purpose, including commercial blogs, websites, and marketing materials."
    }
  ];

  return (
    <section id="faq" className="scroll-mt-16">
      <div className="flex items-center justify-center gap-3 mb-12">
        <HelpCircle className="w-8 h-8 text-indigo-600" />
        <h2 className="text-3xl font-bold text-gray-900">Frequently Asked Questions</h2>
      </div>
      <div className="space-y-6 max-w-3xl mx-auto">
        {faqs.map((faq, index) => (
          <div key={index} className="bg-white rounded-xl shadow-lg p-6">
            <h3 className="text-xl font-semibold mb-2">{faq.question}</h3>
            <p className="text-gray-600">{faq.answer}</p>
          </div>
        ))}
      </div>
    </section>
  );
}